import { Box, HStack, InlineFormattedNumber, SummaryLineWrapper, Total } from '@talos/kyoko';

interface CustomerCreditsSummaryLineProps {
  currentCount: number;
  maxCount: number;
}

export const CustomerCreditsSummaryLine = ({ currentCount, maxCount }: CustomerCreditsSummaryLineProps) => {
  return (
    <SummaryLineWrapper alignItems="center" w="100%" data-testid="customer-credits-summary">
      <HStack px="spacing4">
        <Total data-testid="customer-credits-summary-label">Credit Limits:</Total>
        <Box data-testid="customer-credits-summary-value">
          <InlineFormattedNumber number={currentCount} increment={null} truncate={false} />
          {' / '}
          <InlineFormattedNumber number={maxCount} increment={null} truncate={false} />
          {' accounts'}
        </Box>
      </HStack>
    </SummaryLineWrapper>
  );
};
